<template>
  <div>
    <div class="margin-body d-flex align-items-start justify-content-between">
      <img :src="require(`@/assets/images/APRILYOS/logo.png`)" alt="Logo" class="mt-auto mb-auto sidebar-header-logo-back"
           width="200px">
      <b-navbar-nav class="d-none d-md-block">

        <b-nav-item-dropdown right style="width: 300px;" class="d-flex align-items-end justify-content-end">
          <!-- Using 'button-content' slot -->
          <template #button-content>
            {{ $store.getters.username }}
          </template>
          <b-dropdown-item @click="goToProfile">
            {{ $t('Profile') }}
          </b-dropdown-item>
          <b-dropdown-item @click="showMyAccountModal">
            {{ $t('user.Password') }}
          </b-dropdown-item>
          <b-dropdown-item @click="showReportBugModal">
            {{ $t('Report.a.bug') }}
          </b-dropdown-item>
          <b-dropdown-item @click="logout">
            {{ $t('Logout') }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </div>

    <div class="margin-content">
      <div class="d-flex justify-content-between">
        <back-arrow :title="venteLot.tostring"/>
        <div>
          <b-button class="mr-2 px-5" variant="outline-primary" @click="downloadVenteLot()">
            {{ $t('venteLot.Download') }}
          </b-button>
          <b-button class="px-5" v-if="venteLot.statut === 'DISPONIBLE'" variant="primary" @click="showModalPrereserver">
            {{ $t('venteLot.Prereserver') }}
          </b-button>
        </div>
      </div>

      <div class="row mr-2 ml-2 mt-2">
        <div v-for="(img, index) in visibleImages" :key="img.id" class="col-md-4 col-6 img-container">
          <b-img :src="img.fileUrl" alt="Image" class="img-annonce cursor-pointer"
                 @click="toggler = !toggler"></b-img>
          <div v-if="index === 2 && moreImagesCount" class="overlay cursor-pointer" @click="toggler = !toggler">
            +{{ moreImagesCount }}
          </div>
        </div>
        <FsLightbox
          :sources="this.sourceImg"
          :toggler="toggler"
          type="image"/>
      </div>

      <div class="row mt-4">
        <div class="col-md-9">
          <b-card>
            <p class="card-title">{{ $t('venteLot.Details') }}</p>
            <div class="row mt-4">
              <div class="col-md-4">
                <span v-if="venteLot.statut === 'DISPONIBLE'" class="dispo p-2">
                  {{ $t('vente.lot.statut.enum.disponible') }}
                </span>
                <span v-if="venteLot.statut === 'VENDU'" class="vendu p-2">
                  {{ $t('vente.lot.statut.enum.vendu') }}
                </span>
                <span v-if="venteLot.statut === 'PRE_RESERVE' || venteLot.statut === 'A_VALIDER'" class="prereserver p-2">
                  {{ $t('vente.lot.statut.enum.prereserve') }}
                </span>
              </div>
              <div class="col-md-4 d-flex align-items-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     stroke="#6D84C4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="mr-3 icon icon-tabler icons-tabler-outline icon-tabler-ruler">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path
                    d="M5 4h14a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-7a1 1 0 0 0 -1 1v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1"/>
                  <path d="M4 8l2 0"/>
                  <path d="M4 12l3 0"/>
                  <path d="M4 16l2 0"/>
                  <path d="M8 4l0 2"/>
                  <path d="M12 4l0 3"/>
                  <path d="M16 4l0 2"/>
                </svg>
                {{ venteLot.surface }}m²
              </div>
              <div class="col-md-4 d-flex align-items-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     stroke="#6D84C4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="mr-3 icon icon-tabler icons-tabler-outline icon-tabler-stairs">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M22 5h-5v5h-5v5h-5v5h-5"/>
                </svg>
                {{ venteLot.etage }}
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-4 d-flex align-items-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     stroke="#6D84C4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="mr-3 icon icon-tabler icons-tabler-outline icon-tabler-hammer">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M11.414 10l-7.383 7.418a2.091 2.091 0 0 0 0 2.967a2.11 2.11 0 0 0 2.976 0l7.407 -7.385"/>
                  <path
                    d="M18.121 15.293l2.586 -2.586a1 1 0 0 0 0 -1.414l-7.586 -7.586a1 1 0 0 0 -1.414 0l-2.586 2.586a1 1 0 0 0 0 1.414l7.586 7.586a1 1 0 0 0 1.414 0z"/>
                </svg>
              </div>
              <div class="col-md-4 d-flex align-items-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     stroke="#6D84C4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="mr-3 icon icon-tabler icons-tabler-outline icon-tabler-hammer">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M11.414 10l-7.383 7.418a2.091 2.091 0 0 0 0 2.967a2.11 2.11 0 0 0 2.976 0l7.407 -7.385"/>
                  <path
                    d="M18.121 15.293l2.586 -2.586a1 1 0 0 0 0 -1.414l-7.586 -7.586a1 1 0 0 0 -1.414 0l-2.586 2.586a1 1 0 0 0 0 1.414l7.586 7.586a1 1 0 0 0 1.414 0z"/>
                </svg>
                {{ venteLot.brutRenove }}
              </div>
              <div class="col-md-4 d-flex align-items-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     stroke="#6D84C4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="mr-3 icon icon-tabler icons-tabler-outline icon-tabler-building-community">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M8 9l5 5v7h-5v-4m0 4h-5v-7l5 -5m1 1v-6a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v17h-8"/>
                  <path d="M13 7l0 .01"/>
                  <path d="M17 7l0 .01"/>
                  <path d="M17 11l0 .01"/>
                  <path d="M17 15l0 .01"/>
                </svg>
                {{ venteLot.type }}
              </div>
            </div>
            <p class="card-title mt-4">{{ $t('venteLot.Description') }}</p>


            <div v-html="formatDescription(venteLot.description)"></div>
          </b-card>

          <b-card class="mt-2">
            <div class="card-title">{{ $t('venteLot.Documents') }}</div>
            <div v-if="documents.length === 0">
              {{ $t('venteLot.aucunDocument') }}
            </div>
            <b-row v-else>
              <b-col :key="'document-' + index" class="document-section col col-md-6 px-3 mt-2" v-for="(document, index) in documents">
                <div @click="downloadOldFile(document)" class="border rounded p-2">
                  <div class="text-center"
                       v-if="document.extension === '.jpg' || document.extension === '.jpeg' || document.extension === '.png'">
                    <img class="m-auto documentVente" :src="document.fileUrl" alt="Image preview"/>
                  </div>
                  <div class="text-center" v-else-if="document.extension === '.pdf'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                         stroke="#9E0430" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                         class="icon icon-tabler icons-tabler-outline icon-tabler-file-type-pdf">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
                      <path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"/>
                      <path d="M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6"/>
                      <path d="M17 18h2"/>
                      <path d="M20 15h-3v6"/>
                      <path d="M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"/>
                    </svg>
                  </div>
                  <div v-else class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                         stroke="#07153C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                         class="icon icon-tabler icons-tabler-outline icon-tabler-file-info">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
                      <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/>
                      <path d="M11 14h1v4h1"/>
                      <path d="M12 11h.01"/>
                    </svg>
                  </div>
                </div>
                <div class="text-center mt-2">
                  {{ document.name }}
                </div>
              </b-col>
            </b-row>
          </b-card>
        </div>

        <div class="col-md-3">
          <b-card>
            <p class="card-title">{{ $t('venteLot.PrixVente') }}</p>
            <span class="prixVente">{{ venteLot.prix }}€</span>
          </b-card>

          <b-card class="mt-2">
            <p class="card-title">{{ $t('venteLot.Localisation') }}</p>
            {{ venteLot.address }}<br/>
            {{ venteLot.postalCode }} {{ venteLot.city }}
            <GmapMap
              ref="gmap"
              :center="{lat:this.latitude, lng:this.longitude}"
              :zoom="14"
              class="mt-2"
              :options="{
                 zoomControl: true,
                 mapTypeControl: false,
                 scaleControl: false,
                 streetViewControl: false,
                 rotateControl: false,
                 fullscreenControl: false,
                 disableDefaultUi: false
              }"
              style="width: 100%; height: 300px">

              <GmapMarker
                :position="{lat:this.latitude, lng:this.longitude}"
                :clickable="false"
                :draggable="false"
              />

            </GmapMap>
          </b-card>
        </div>
      </div>
    </div>

    <PrereserverModal :vente-lot="venteLot" @didPrereserver="didPrereserver"/>

  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/b122/BackArrow.vue";
import B122Carroussel from "./B122Carroussel.vue";
import PrereserverModal from "./PrereserverModal.vue";
import FsLightbox from "fslightbox-vue/v2"


export default {

  name: "VenteLotShowAgent",
  components: {PrereserverModal, B122Carroussel, BackArrow,FsLightbox},

  data() {
    return {
      venteLotId: this.$route.params.venteLotId,
      venteLot: {},
      proposition: [],
      photos: [],
      latitude: 0,
      longitude: 0,
      documents: [],
      visibleImages: [],
      moreImagesCount: 0,
      toggler: false,
      sourceImg: [],
    }
  },

  computed: {
    getValue() {
      return property => (this.user[property] || this.user[property] === false) ? this.user[property] : 'N/A'
    },
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    downloadOldFile(file) {
      if (!file.hasOwnProperty('fileUrl')) {
        this.downloadNewFile(file)
        return
      }
      api({
        method: 'GET',
        url: file.fileUrl,
        responseType: 'blob'
      })
        .then(response => {
          let a = document.createElement('a')
          let blob = new Blob([response.data])
          let url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = file.fileName
          a.click()
          window.URL.revokeObjectURL(url)
        })
    },

    formatDescription(description) {
      if (description) {
        return description.replace(/\n/g, '<br>');
      }
      return '';
    },

    async fetchData() {
      await this.fetchVenteLot()
      await this.fetchPhotos()
      await this.fetchDocuments()
    },

    async fetchVenteLot() {
      api
        .get(`/venteLot/${this.venteLotId}`)
        .then(response => {
          this.venteLot = response.data
          this.$refs.gmap.$mapPromise.then((map) => {
            let geocoder = new google.maps.Geocoder();
            let context = this;
            let address = this.venteLot.address + ' ' + this.venteLot.postalCode + ' ' + this.venteLot.city;
            geocoder.geocode({ 'address': address }, function (results, status) {
              if (status === google.maps.GeocoderStatus.OK) {
                context.latitude = results[0].geometry.location.lat();
                context.longitude = results[0].geometry.location.lng();
              }
            });
          })
        })
        .catch((error) => {
          this.$router.push({
            name: 'VenteLotIndex',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    async fetchPhotos() {
      api
        .get(`/venteLotDocument/getPhotos/${this.venteLotId}`)
        .then(response => {
          this.photos = response.data
          this.prepareVisibleImages()
        })
        .catch((error) => {
          this.$router.push({
            name: 'VenteLotIndex',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    async fetchDocuments() {
      api
        .get(`/venteLotDocument/getDocuments/${this.venteLotId}`)
        .then(response => {
          this.documents = response.data
        })
        .catch((error) => {
          this.$router.push({
            name: 'VenteLotIndex',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },

    async logout() {
      this.$store.commit('setUnsavedChanges', false);
      await this.$store.dispatch('LogOut')
      await this.$router.push('/login')
    },

    showMyAccountModal() {
      this.$bvModal.show('change-password-modal')
    },

    goToProfile() {
      this.$router.push({
        name: 'ProfileShow'
      })
    },

    prepareVisibleImages() {
      this.visibleImages = this.photos.slice(0, 3);
      this.moreImagesCount = this.photos.length - this.visibleImages.length;
      this.sourceImg = this.photos.map(file => file.fileUrl);
    },


    showReportBugModal() {
      this.$bvModal.show('show-bug-report-modal');
    },

    showModalPrereserver() {
      this.$bvModal.show('prereserver-modal');
    },

    downloadVenteLot() {
      api.post(`/venteLot/downloadPdf/${this.venteLotId}`, {}, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/x-zip'
        }
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Annonce-${this.venteLot.tostring}-${new Date().toLocaleDateString('fr-FR')}.zip`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        // this.loadingPdf = false
      }).catch(() => {
        // this.loadingPdf = false
      })
    },

    didPrereserver() {
      this.fetchVenteLot()
      this.successToast(this.$i18n.t('venteLot.success'))
    }
  }
}

</script>

<style scoped>

.document-section {
  cursor: pointer;
}

.dispo {
  border-radius: 30px;
  text-align: center;
  background: #06C9B3;
  color: white;
}

.prereserver {
  border-radius: 30px;
  text-align: center;
  background: #009DFF;
  color: white;
}

.valider {
  border-radius: 30px;
  text-align: center;
  background: #9E0430;
  color: white;
}

.vendu {
  border-radius: 30px;
  text-align: center;
  background: #FF9D00;
  color: white;
}

.margin-content {
  padding: 25px 200px;
  background-color: var(--background-grey);
}

.margin-body {
  padding: 25px 100px;
  background-color: white;
}

.sidebar-header-logo-back {
  margin-right: 100px;
}

.card-title {
  color: var(--main-text-color);
  font-size: 16px;
  font-family: "Montserrat-Bold", "Arial", sans-serif;
}

.prixVente {
  color: var(--tertiary-text-color);
  font-size: 16px;
  font-family: "Montserrat-Bold", "Arial", sans-serif;
}

.documentVente {
  max-width: 100%;
  max-height: 200px;
  width: auto;
  height: auto;
}



.img-container {
  padding: 5px;
}

.img-annonce {
  border-radius: var(--main-border-radius);
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 98%;
  height: 200px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: var(--main-border-radius);
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 22px;

}

@media (max-width: 768px) {
  .img-container {
    padding-bottom: 5px;
  }
}


</style>



// WEBPACK FOOTER //
// src/views/venteLot/VenteLotShowAgent.vue